import type { FunctionComponent } from 'react';

/**
 * Renders children with a separator character (eg: "•")
 */
const WithSeparator: FunctionComponent = ({ children }) => (
  <> {children} <div className="issue-item__field-separator">•</div></>
);

export default WithSeparator;
